/**
 * Variant Drawer — Quick Add from Collection pages
 * Pill/dropdown option selectors · image gallery · the product page's add-ons (Sizing, Size Note, base color, rush)
 */
(function () {
  if (customElements.get('variant-drawer-trigger')) return;

  var drawer   = document.getElementById('Variant-Drawer');
  var overlay  = document.getElementById('Variant-Drawer-Overlay');
  if (!drawer || !overlay) return;

  var heroWrap  = document.getElementById('vd-hero');
  var heroImg   = document.getElementById('vd-hero-img');
  var heroPrev  = document.getElementById('vd-hero-prev');
  var heroNext  = document.getElementById('vd-hero-next');
  var headerImg = document.getElementById('vd-header-img');
  var titleEl   = document.getElementById('vd-title');
  var priceEl   = document.getElementById('vd-price');
  var optionsEl = document.getElementById('vd-options');
  var addBtn    = document.getElementById('vd-add-btn');
  var addError  = document.getElementById('vd-add-error');
  var viewLink  = document.getElementById('vd-view-link');
  var vdForm    = document.getElementById('vd-form');
  var vdId      = vdForm && vdForm.querySelector('[name="id"]');

  drawer.querySelectorAll('.vd-close').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
  });

  var PILL_THRESHOLD = 6;
  var currentProduct = null;
  var selected = {};
  var productImages = [];
  var heroIndex = 0;
  var cache = new Map();

  // Closed, the drawer is only moved off-screen, so `inert` keeps its controls out of the tab order.
  var opener = null;
  function openDrawer() {
    // Hand focus back on close only to a keyboard opener; a mouse-clicked card button would keep its focus colour.
    opener = document.activeElement && document.activeElement.matches(':focus-visible') ? document.activeElement : null;
    drawer.inert = false;
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    // Both close buttons can still be hidden at this moment (the image row shows only once the product loads),
    // so fall back to the dialog itself; screen readers then announce its title.
    requestAnimationFrame(function () {
      var close = Array.prototype.find.call(drawer.querySelectorAll('.vd-close'), function (b) { return b.offsetParent; });
      if (close) close.focus({ preventScroll: true });
      else { drawer.tabIndex = -1; drawer.focus({ preventScroll: true }); }
    });
  }
  function closeDrawer() {
    if (drawer.inert) return;
    drawer.inert = true;
    if (opener && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    currentProduct = null;
    selected = {};
  }

  /* ── Helpers ── */
  // Both fetchers cache the request itself, so a click while the hover prefetch is still loading waits for it instead of asking again.
  function fetchProduct(handle) {
    if (cache.has(handle)) return Promise.resolve(cache.get(handle));
    var url = (theme.routes.root_url + '/products/' + handle + '.js').replace('//', '/');
    var p = fetch(url).then(function (r) { return r.json(); });
    cache.set(handle, p);
    p.catch(function () { cache.delete(handle); });
    return p;
  }

  /* The product page's add-ons for this product, same rules and wording (templates/product.joyee-quick.liquid).
     None means a plain quick add. A failed request must not: on all-size colour products Size and Length & Shape
     live in these add-ons, so the set would go in with no size. It fails the drawer instead and isn't kept. */
  function fetchAddons(handle) {
    var key = 'addons:' + handle;
    if (cache.has(key)) return Promise.resolve(cache.get(key));
    var url = (theme.routes.root_url + '/products/' + handle + '?view=joyee-quick').replace('//', '/');
    var p = fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).catch(function (e) {
      cache.delete(key);
      throw e;
    });
    cache.set(key, p);
    return p;
  }
  /* innerHTML doesn't run scripts: put fresh copies in their place so they run, right after their markup. */
  function runScripts(el) {
    el.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
  }

  // In a .money span, like the rest of the theme, so BUCKS converts it for a visitor on another currency.
  function setPrice(cents) {
    priceEl.innerHTML = '<span class="money">' + formatMoney(cents) + '</span>';
    if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') window.bucksCC.reConvert();
  }

  function formatMoney(cents) {
    var a = (cents / 100).toFixed(2);
    var n = Math.round(cents / 100).toString();
    var fmt = (theme.settings.money_with_currency_format || '${{amount}}').replace(/<[^>]*>/g, '');
    return fmt.replace('{{amount}}', a).replace('{{amount_no_decimals}}', n)
      .replace('{{amount_with_comma_separator}}', a.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).trim();
  }

  function sizedImg(url, size) {
    return url ? url.replace(/(_\d+x\d+)?(\.[^.]+)(\?.*)?$/, '_' + size + '$2$3') : '';
  }

  function rawImgSrc(v, product) {
    var r = (v && v.featured_image && v.featured_image.src) || (v && v.featured_image) || product.featured_image;
    return (typeof r === 'object' && r !== null) ? (r.src || '') : (r || '');
  }

  // 用于 HTML 属性拼接（data-option="…"、data-value="…"、<option value="…">），
  // 所以必须转义引号。原实现走 textContent -> innerHTML，只转义 & < >，
  // 选项值里一旦含 " 就会截断属性。与 joyee-bundle-builder.js 的 esc 保持同一语义。
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Display only, as snippets/variant-value-label.liquid: the value sent stays "Custom Size-Add Note". */
  function valueLabel(val) { return val === 'Custom Size-Add Note' ? 'Custom' : val; }

  /* ── Image gallery ── */
  function setHeroImage(idx) {
    if (!productImages.length) return;
    heroIndex = ((idx % productImages.length) + productImages.length) % productImages.length;
    var newSrc = sizedImg(productImages[heroIndex], '600x600');
    if (heroImg.src.indexOf(newSrc.split('?')[0]) !== -1) return; // same image
    heroImg.style.opacity = '0';
    heroImg.onload = function () { heroImg.style.opacity = '1'; heroImg.onload = null; };
    heroImg.src = newSrc;
  }

  if (heroPrev) heroPrev.addEventListener('click', function () { setHeroImage(heroIndex - 1); });
  if (heroNext) heroNext.addEventListener('click', function () { setHeroImage(heroIndex + 1); });

  /* ── Variant matching ── */
  function findVariant() {
    if (!currentProduct) return null;
    var opts = currentProduct.options;
    for (var i = 0; i < opts.length; i++) {
      if (!selected[opts[i].name]) return null;
    }
    return currentProduct.variants.find(function (v) {
      return currentProduct.options.every(function (opt) {
        return v['option' + opt.position] === selected[opt.name];
      });
    }) || null;
  }

  function getAvailable(optName) {
    var pos = currentProduct.options.find(function (o) { return o.name === optName; }).position;
    var avail = new Set();
    currentProduct.variants.forEach(function (v) {
      if (!v.available) return;
      var ok = true;
      currentProduct.options.forEach(function (opt) {
        if (opt.name === optName) return;
        if (selected[opt.name] && v['option' + opt.position] !== selected[opt.name]) ok = false;
      });
      if (ok) avail.add(v['option' + pos]);
    });
    return avail;
  }

  /* ── Update display ── */
  function updateDisplay() {
    var v = findVariant();
    if (v) {
      var src = rawImgSrc(v, currentProduct);
      if (src) {
        var newHeroSrc = sizedImg(src, '600x600');
        if (heroImg.src !== newHeroSrc) {
          heroImg.style.opacity = '0';
          heroImg.onload = function () { heroImg.style.opacity = '1'; heroImg.onload = null; };
          heroImg.src = newHeroSrc;
        }
        headerImg.src = sizedImg(src, '200x200');
        // Sync gallery index to variant image
        var srcBase = src.replace(/_\d+x\d+/, '').split('?')[0];
        for (var i = 0; i < productImages.length; i++) {
          if (productImages[i].replace(/_\d+x\d+/, '').split('?')[0] === srcBase) {
            heroIndex = i; break;
          }
        }
      }
      setPrice(v.price);
      addBtn.disabled = false;
    } else {
      addBtn.disabled = true;
    }
    if (vdId && vdId.value !== String(v ? v.id : '')) {
      vdId.value = v ? v.id : '';
      vdId.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateStates() {
    currentProduct.options.forEach(function (opt) {
      var avail = getAvailable(opt.name);
      // Pills
      optionsEl.querySelectorAll('[data-option="' + opt.name + '"] .vd-pill').forEach(function (pill) {
        var val = pill.dataset.value;
        pill.classList.toggle('vd-pill--selected', selected[opt.name] === val);
        pill.setAttribute('aria-pressed', selected[opt.name] === val);
        pill.classList.toggle('vd-pill--disabled', !avail.has(val));
      });
      // Dropdown
      var sel = optionsEl.querySelector('[data-option="' + opt.name + '"] select');
      if (sel) {
        sel.value = selected[opt.name] || '';
        Array.from(sel.options).forEach(function (o) {
          if (o.value) o.disabled = !avail.has(o.value);
        });
      }
    });

    updateDisplay();
  }

  /* ── Render ── */
  function renderOptions(product, addonsHtml) {
    currentProduct = product;
    var addons = new DOMParser().parseFromString(addonsHtml || '', 'text/html');
    var addonsBefore = addons.querySelector('[data-vd-before]'), addonsAfter = addons.querySelector('[data-vd-after]');
    selected = {};

    // Images array
    productImages = (product.images || []).map(function (img) {
      return (typeof img === 'object') ? (img.src || '') : (img || '');
    });
    var firstSrc = rawImgSrc(null, product);
    if (firstSrc) {
      heroImg.src = sizedImg(firstSrc, '600x600');
      headerImg.src = sizedImg(firstSrc, '200x200');
      heroWrap.style.display = '';
      headerImg.style.display = '';
      heroIndex = 0;
    } else {
      heroWrap.style.display = 'none';
      headerImg.style.display = 'none';
    }
    // Show/hide gallery arrows
    var hasMulti = productImages.length > 1;
    if (heroPrev) heroPrev.style.display = hasMulti ? '' : 'none';
    if (heroNext) heroNext.style.display = hasMulti ? '' : 'none';

    titleEl.textContent = product.title;
    setPrice(product.price);
    viewLink.href = product.url;

    // Build HTML: the add-ons that go above the options (Sizing on sized products), the options, the rest
    var html = '<div class="vd-addons">' + (addonsBefore ? addonsBefore.innerHTML : '') + '</div>';
    product.options.forEach(function (opt) {
      var seen = new Set();
      var values = [];
      product.variants.forEach(function (v) {
        var val = v['option' + opt.position];
        if (!seen.has(val)) { seen.add(val); values.push(val); }
      });

      html += '<div class="vd-group" data-option="' + esc(opt.name) + '" role="group" aria-label="' + esc(opt.name) + '">';
      html += '<p class="vd-group__label">' + esc(opt.name) + '</p>';

      if (values.length > PILL_THRESHOLD) {
        // Dropdown
        html += '<select class="vd-select" aria-label="' + esc(opt.name) + '">';
        values.forEach(function (val) {
          html += '<option value="' + esc(val) + '">' + esc(valueLabel(val)) + '</option>';
        });
        html += '</select>';
      } else {
        // Pills
        html += '<div class="vd-group__pills">';
        values.forEach(function (val) {
          html += '<button type="button" class="vd-pill" data-value="' + esc(val) + '" aria-pressed="false">' + esc(valueLabel(val)) + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });

    html += '<div class="vd-addons">' + (addonsAfter ? addonsAfter.innerHTML : '') + '</div>';

    // Description
    if (product.description) {
      var desc = product.description.replace(/<[^>]*>/g, '').trim();
      if (desc.length > 200) desc = desc.substring(0, 200) + '…';
      if (desc) {
        html += '<div class="vd-desc">' + desc + '</div>';
      }
    }

    optionsEl.innerHTML = html;
    optionsEl.scrollTop = 0;
    runScripts(optionsEl);

    // Bind pills
    optionsEl.querySelectorAll('.vd-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('vd-pill--disabled')) return;
        var optName = pill.closest('.vd-group').dataset.option;
        var val = pill.dataset.value;
        selected[optName] = (selected[optName] === val) ? undefined : val;
        if (!selected[optName]) delete selected[optName];
        updateStates();
      });
    });

    // Bind dropdowns
    optionsEl.querySelectorAll('.vd-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var optName = sel.closest('.vd-group').dataset.option;
        if (sel.value) { selected[optName] = sel.value; } else { delete selected[optName]; }
        updateStates();
      });
    });

    // Default: select first available variant's options
    var firstAvail = product.variants.find(function (v) { return v.available; });
    if (firstAvail) {
      product.options.forEach(function (opt) {
        selected[opt.name] = firstAvail['option' + opt.position];
      });
    }

    addBtn.classList.remove('loading');
    updateStates();

    // Preload all product images for instant gallery switching
    productImages.forEach(function (src) {
      if (src) { var img = new Image(); img.src = sizedImg(src, '600x600'); }
    });
  }

  /* ── Add to cart ── */
  function getSectionsKeys() {
    return [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }
  function parseSectionHTML(html, sel) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    return el ? el.innerHTML : '';
  }

  /* "Send me all sizes" on a sized product: hide the Size row and keep the variant on the first size,
     as the product page does (snippets/joyee-allsize.liquid). */
  optionsEl.addEventListener('change', function (e) {
    if (e.target.name !== 'properties[Sizing]' || !currentProduct) return;
    var sizeOpt = currentProduct.options.find(function (o) { return (o.values || []).indexOf('XS') !== -1; });
    var group = sizeOpt && optionsEl.querySelector('.vd-group[data-option="' + sizeOpt.name + '"]');
    if (!group) return;
    var all = e.target.value === 'Send me all sizes';
    group.style.display = all ? 'none' : '';
    if (all) { selected[sizeOpt.name] = sizeOpt.values[0]; updateStates(); }
  });

  addBtn.addEventListener('click', function () {
    var v = findVariant();
    if (!v || addBtn.classList.contains('loading')) return;

    // Length & Shape on all-size colour products has no default, as on the product page
    var len = optionsEl.querySelector('[data-allsize-length]');
    if (len && !len.disabled && !len.value) {
      var err = len.closest('fieldset').querySelector('.joyee-allsize__error');
      if (err) err.hidden = false;
      len.focus();
      return;
    }

    addBtn.classList.add('loading');
    addBtn.disabled = true;
    addError.hidden = true;
    var showAddError = function (message) {
      addError.textContent = message;
      addError.hidden = false;
      addBtn.disabled = false;
    };

    // The add-ons' controls (Sizing, Size Note, base color, rush, their _addons list) come with the form.
    // A submit event, not a submit: the add-ons script sets _addons on it, as on the product page.
    vdForm.dispatchEvent(new Event('submit', { cancelable: true }));
    var fd = new FormData(vdForm);
    fd.set('id', v.id);
    fd.set('quantity', 1);

    fd.append('sections', getSectionsKeys().map(function (s) { return s.section; }));
    fd.append('sections_url', window.location.pathname);

    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { console.error('ATC error:', res.description); showAddError(res.description || theme.strings.cartError); return; }
        getSectionsKeys().forEach(function (sec) {
          var el = document.getElementById(sec.id);
          if (!el || !res.sections || !res.sections[sec.section]) return;
          (el.querySelector(sec.selector) || el).innerHTML = parseSectionHTML(res.sections[sec.section], sec.selector);
        });
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { product: res.hasOwnProperty('items') ? res.items[0] : res }
        }));
        closeDrawer();
        var cd = document.getElementById('Cart-Drawer');
        if (cd && typeof cd.open === 'function') cd.open();
        // A stale drawer snapshot can miss the set just added.
        if (cd && typeof cd.verifyAfterAdd === 'function') cd.verifyAfterAdd(res.items ? res.items.map(function (i) { return i.key; }) : [res.key]);
      })
      .catch(function (e) { console.error('VD ATC error:', e); showAddError(theme.strings.cartError); })
      .finally(function () { addBtn.classList.remove('loading'); });
  });

  /* ── Trigger custom element ── */
  var openSeq = 0;
  class VariantDrawerTrigger extends HTMLElement {
    connectedCallback() {
      // Carousels re-attach cards (connectedCallback runs again): bind once, or every move adds another set of listeners.
      if (this._vdBound) return;
      this._vdBound = true;
      this.addEventListener('click', this._onClick.bind(this));
      // Desktop only: resting on the button for 150ms starts loading what the drawer needs, so it opens with the options ready.
      // Not on touch, where a press is too short to gain anything and scrolling past cards would fetch for nothing.
      if (window.matchMedia('(hover: hover)').matches) {
        var timer;
        this.addEventListener('mouseenter', function () {
          var handle = this.dataset.productHandle;
          if (handle && !this.hasAttribute('disabled')) timer = setTimeout(function () { fetchProduct(handle).catch(function () {}); fetchAddons(handle); }, 150);
        });
        this.addEventListener('mouseleave', function () { clearTimeout(timer); });
      }
      // The card button is a custom element, not a <button>: give it the role and keys of one so keyboard and
      // screen-reader users can open quick add. The small icon on the image repeats it and stays out of the tab order.
      if (this.classList.contains('product-card-quickview--mini')) return;
      this.setAttribute('role', 'button');
      if (this.hasAttribute('disabled')) this.setAttribute('aria-disabled', 'true');
      this.tabIndex = 0;
      this.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && !this.hasAttribute('disabled')) { e.preventDefault(); this.click(); }
      });
    }
    _onClick(e) {
      e.preventDefault(); e.stopPropagation();
      var handle = this.dataset.productHandle;
      if (!handle || this.classList.contains('loading')) return;
      optionsEl.innerHTML = '<div class="vd-loading"></div>';
      addError.hidden = true;
      // Name the dialog before focus moves in (the product loads after), so a screen reader hears which product.
      var cardTitle = this.closest('.product-card') && this.closest('.product-card').querySelector('.product-card-title');
      titleEl.textContent = cardTitle ? cardTitle.textContent.trim() : ''; priceEl.textContent = '';
      heroWrap.style.display = 'none'; headerImg.style.display = 'none';
      addBtn.disabled = true;
      openDrawer();
      this.classList.add('loading');
      var self = this;
      // Only the card tapped last may fill the drawer: a slow earlier reply would swap the product under the shopper.
      var seq = ++openSeq;
      Promise.all([fetchProduct(handle), fetchAddons(handle)]).then(function (r) { if (seq === openSeq) renderOptions(r[0], r[1]); })
        .catch(function () { if (seq !== openSeq) return; optionsEl.innerHTML = '<p style="padding:20px;text-align:center;color:#999;"></p>'; optionsEl.firstChild.textContent = drawer.dataset.loadError || 'Failed to load.'; })
        .finally(function () { self.classList.remove('loading'); });
    }
  }
  customElements.define('variant-drawer-trigger', VariantDrawerTrigger);
})();